<div (click)="onMenuItemSelected(menuItem)" class="search-result-item" [ngClass]="getSearchResultItemActiveClass">
  @if (parentName) {
    <a (click)="triggerMenuItemClick($event,menuItemComponent)" class="path" [title]="parentName" href="#"
      >
      <span [ngClass]="getParentIcon()"></span>
      <span class="path-title" [innerText]="parentName"></span>
    </a>
  }
  <scitis-menu-item #menuItemComponent [menuItem]="menuItem" [fireMenuItemSelectAction]="false" [useHighlighting]="true"
    [highlightTerms]="searchTerms"
    class="scitis-menu-item">
  </scitis-menu-item>
</div>

